import { authenticatedFetch, getApiUrl } from '@/utils/auth/authService';

// userTranslator.js toJsonAPI(): a pure mapping copied verbatim, no VM state involved.
function toJsonAPI(user, password) {
	return {
		deliveryLocationHomeId: user.deliveryLocationHomeId,
		customerCode: user.customerCode,
		username: user.userName,
		password: password || '',
		firstName: user.firstName,
		lastName: user.lastName,
		email: user.email,
		locale: user.locale,
		timezone: user.timezone,
	};
}

// nav.js saveUser(): PUT Core/Users/{id}. Its `Token: ctx.user.tokenApp || ctx.user.token` header
// looked security-sensitive, but tokenApp is never assigned anywhere in public/m.eagle (always ''),
// so it's always plain `token` in practice - the same token authenticatedFetch() already sends.
export async function updateUser(user, newPassword) {
	const response = await authenticatedFetch(getApiUrl(`Core/Users/${user.id}`), { method: 'PUT', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(toJsonAPI(user, newPassword)) }, 'token');
	if (response.ok) return { ok: true };
	const body = await response.json().catch(() => null);
	return { ok: false, code: body?.code ?? null };
}
